export default "__VITE_ASSET__CCg9LgyL__"